export enum BestType {
  Monthly = 'Monthly',
  Weekly = 'Weekly',
  Daily = 'Daily',
  Realtime = 'Realtime',
}

export const BestTypeList = [BestType.Realtime, BestType.Daily, BestType.Weekly, BestType.Monthly];
export const BestTypeDisplayList = [BestType.Realtime, BestType.Daily, BestType.Weekly];

export const BestTypeString = {
  [BestType.Weekly]: '주간',
  [BestType.Monthly]: '월간',
  [BestType.Daily]: '하루',
  [BestType.Realtime]: '실시간',
};

export const BestTypeOptions = BestTypeList.map(it => ({ label: BestTypeString[it], id: it, value: it }));

export const RankingPagePath = {
  [BestType.Weekly]: 'weekly',
  [BestType.Monthly]: 'monthly',
  [BestType.Daily]: 'daily',
  [BestType.Realtime]: 'realtime',
};

export const BEST_PAGE_ITEM_COUNT = 100;
export const MAX_BEST_CONTENTS_COUNT = 100;
